module.exports = __webpack_public_path__ + "img/ydy1@3x.719be0f7.png";